import { inject, Injectable, NgZone } from '@angular/core';
import { environment } from '../../../environments/environment';
import { v4 as uuidv4 } from 'uuid';
import { LoginEndProfile } from 'src/app/auth/models/login-end';

@Injectable({
    providedIn: 'root'
})
export class GibService {
    private w = window as any;
    private ngZone = inject(NgZone)

    constructor() { }
    

    // Initialize Group-IB snippet once
    initGIB() {
        this.ngZone.runOutsideAngular(() => {
            const w = window as any;
            const init = () => {
                w.gib.init({
                    cid: environment.gib.cid,
                    backUrl: environment.gib.backUrl,
                });
                console.log('Group-IB initialized for login module');
            };

            if (typeof w.gib === 'undefined') {
                w.onGIBLoad = function () {
                    init();
                };
            } else {
                init();
            }
        })
    }


    //  Set user as authorized with identity and session
    setUserAuth(userDetail?: LoginEndProfile) {
        if (!this.w.gib) {
            console.warn('GIB snippet not ready yet');
            return;
        }

        const deviceUUID = localStorage.getItem('deviceUUID')
        this.w.gib.setSessionID(deviceUUID);
        this.w.gib.setAuthStatus(this.w.gib.IS_AUTHORIZED);

        const loginDetails = this.loginEnd;
        if (!loginDetails) {
            this.loginEnd = userDetail;
            this.setAttributesValues(userDetail);
        } else {
            this.setAttributesValues(loginDetails);
        }

        console.log('Group-IB user/session info updated');
    }

    setAttributesValues(userDetail: LoginEndProfile) {
      
        this.w.gib.setIdentity(userDetail.entityID); -

        this.w.gib.setAttribute('entity_id', userDetail.entityID);
        this.w.gib.setAttribute('nationality', userDetail.nationality);
        this.w.gib.setAttribute('my_gender', userDetail.gender);
        this.w.gib.setAttribute('entity_type', 'suppliers');
        this.w.gib.setAttribute('account_status', userDetail.accountStatus);
        this.w.gib.setAttribute('creation_date', userDetail.registrationDate);
        this.w.gib.setAttribute('uuid', uuidv4());
        this.w.gib.setAttribute('mobile_number', userDetail.mobile);
    }

    // Reset snippet to guest / unauthorized state
    setGuest() {
        if (!this.w.gib) return;

        this.w.gib.setAuthStatus(this.w.gib.IS_GUEST);
        this.w.gib.setIdentity(null);
        this.w.gib.setSessionID(null);

        this.w.gib.setAttribute('entity_id', null);
        this.w.gib.setAttribute('nationality', null);
        this.w.gib.setAttribute('my_gender', null);
        this.w.gib.setAttribute('entity_type', null);
        this.w.gib.setAttribute('account_status', null);
        this.w.gib.setAttribute('uuid', null);
        this.w.gib.setAttribute('created_date', null);
        this.w.gib.setAttribute('mobile_number', null);
        
        localStorage.removeItem('loginEnd');

        console.log('Group-IB set to guest/unauthorized');
    }

    private get loginEnd(): LoginEndProfile | null {
        const item = localStorage.getItem('loginEnd');
        return item ? JSON.parse(item) as LoginEndProfile : null;
    }

    private set loginEnd(loginDetail: LoginEndProfile | null) {
        if (loginDetail) {
            localStorage.setItem('loginEnd', JSON.stringify(loginDetail));
        } else {
            localStorage.removeItem('loginEnd');
        }
    }
}
